import useSwr from "@/core/composables/swr/useSwr";
import {surveyApi} from "@/container";
import {computed} from "vue";

/**
 * The survey slug.
 */
const SLUG = 'girerd-consumer-product';

/**
 * Composable to get the Girerd Consumer Product survey for a given consumer key.
 */
const useConsumerProductGirerdSurvey = (consumerKey?: string) => {
    const data = useSwr(
        () => consumerKey && `surveys?slug=${SLUG}&consumer_key=${consumerKey}`,
        () => surveyApi().index({slug: SLUG, consumer_key: consumerKey})
    );

    const survey = computed(() => {
        if (!data.data.value?.data?.length) {
            return undefined;
        }

        return data.data.value.data[0];
    });

    const latestInstance = computed(() => {
        if (!survey.value || !data.data.value?.meta?.latest_instances) {
            return undefined;
        }

        return data.data.value.meta.latest_instances[survey.value.id];
    });

    return {
        ...data,
        survey,
        latestInstance
    };
};

export default useConsumerProductGirerdSurvey;
